// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__20pvw","tab":"ProcedureTabs_tab__2bSGq"};